module.exports = __webpack_public_path__ + "static/img/light-gray.7313452.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/light-gray.png
// module id = fjUl
// module chunks = 1